/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderInfoForKoreaReturnVo } from './OrderInfoForKoreaReturnVo';
import {
    OrderInfoForKoreaReturnVoFromJSON,
    OrderInfoForKoreaReturnVoFromJSONTyped,
    OrderInfoForKoreaReturnVoToJSON,
    OrderInfoForKoreaReturnVoToJSONTyped,
} from './OrderInfoForKoreaReturnVo';

/**
 * 
 * @export
 * @interface ResponseOrderInfoForKoreaReturnVo
 */
export interface ResponseOrderInfoForKoreaReturnVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOrderInfoForKoreaReturnVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOrderInfoForKoreaReturnVo
     */
    message?: string;
    /**
     * 
     * @type {OrderInfoForKoreaReturnVo}
     * @memberof ResponseOrderInfoForKoreaReturnVo
     */
    data?: OrderInfoForKoreaReturnVo;
}

/**
 * Check if a given object implements the ResponseOrderInfoForKoreaReturnVo interface.
 */
export function instanceOfResponseOrderInfoForKoreaReturnVo(value: object): value is ResponseOrderInfoForKoreaReturnVo {
    return true;
}

export function ResponseOrderInfoForKoreaReturnVoFromJSON(json: any): ResponseOrderInfoForKoreaReturnVo {
    return ResponseOrderInfoForKoreaReturnVoFromJSONTyped(json, false);
}

export function ResponseOrderInfoForKoreaReturnVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOrderInfoForKoreaReturnVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OrderInfoForKoreaReturnVoFromJSON(json['data']),
    };
}

export function ResponseOrderInfoForKoreaReturnVoToJSON(json: any): ResponseOrderInfoForKoreaReturnVo {
    return ResponseOrderInfoForKoreaReturnVoToJSONTyped(json, false);
}

export function ResponseOrderInfoForKoreaReturnVoToJSONTyped(value?: ResponseOrderInfoForKoreaReturnVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OrderInfoForKoreaReturnVoToJSON(value['data']),
    };
}

